import type { BetterstartIntegrationDefinition } from '@cli-types/integration-engine/integrations.js'

export const vercelBlobIntegration: BetterstartIntegrationDefinition = {
  id: 'vercel-blob',
  title: 'Vercel Blob',
  description: 'Remote media storage on Vercel Blob',
  kind: 'storage',
  version: '1.0.0',
  dependencies: [],
  conflicts: ['r2', 'railway-bucket'],
  files: [
    {
      outputPath: 'lib/actions/storage/sanitize-filename.ts',
      templatePath: '../_shared/actions/sanitize-filename.ts'
    },
    {
      outputPath: 'lib/actions/storage/object-key.ts',
      templatePath: '../_shared/actions/object-key.ts'
    },
    {
      outputPath: 'lib/actions/vercel-blob/get-token.ts',
      templatePath: 'actions/get-token.ts'
    },
    {
      outputPath: 'lib/actions/vercel-blob/provider.ts',
      templatePath: 'actions/provider.ts'
    }
  ],
  packageDependencies: ['@vercel/blob'],
  devDependencies: [],
  capabilities: {
    storageProvider: {
      provider: 'vercel-blob',
      importPath: '@admin/actions/vercel-blob/provider',
      exportName: 'vercelBlobStorageProvider'
    }
  },
  envSections: [
    {
      // BLOB_READ_WRITE_TOKEN is deliberately unprefixed: it is the name the
      // @vercel/blob SDK reads by default and the one Vercel injects into
      // deployments when a Blob store is connected to the project.
      header: 'Storage (Vercel Blob)',
      vars: [{ key: 'BLOB_READ_WRITE_TOKEN', value: '' }]
    }
  ],
  configure: 'vercel-blob'
}
